import { t } from "@lingui/macro";
import { FitnessProfileAlgorithm } from "@WahooFitness/cloud-client-types";

function getEstimateText({
  algorithmId,
  isRunning,
}: {
  algorithmId?: FitnessProfileAlgorithm;
  isRunning: boolean;
}): string {
  switch (algorithmId) {
    case FitnessProfileAlgorithm.Custom:
      return isRunning
        ? t`The numbers reflected on your Athlete Profile were based on manual input, but your Runner Type, Strengths and Weaknesses remain unchanged.`
        : t`The numbers reflected on your Athlete Profile were based on manual input, but your Rider Type, Strengths, and Weaknesses remain unchanged. To update your Rider Type, Strengths and Weaknesses, take a fitness assessment.`;
    case FitnessProfileAlgorithm.HalfMontyAssessment:
      return t`Your Athlete Profile is generated based on the Half Monty Fitness Assessment you completed in SYSTM. This test accurately measures your Endurance (FTP) and Breakaway (MAP) but estimates your Attack (AC) and Sprint (NM). For the most accurate Athlete Profile, we recommend completing the Full Frontal Fitness Assessment in the SYSTM App.`;
    case FitnessProfileAlgorithm.SystmOnboarding:
      return t`Your Athlete Profile is based on the answers you provided during SYSTM onboarding. For a more accurate estimate, try our Athlete Profile Quiz. To truly dial in your rider type, strengths, and weaknesses, complete the Full Frontal Fitness Assessment in SYSTM.`;
    default:
    case FitnessProfileAlgorithm.FourDPQuiz:
      return isRunning
        ? t`These values are estimates based on your questionnaire answers, not actual training data.`
        : t`These values are estimates based on your questionnaire answers, not actual training data. For the most accurate results, complete the Fitness Assessment in the SYSTM App.`;
  }
}

export default getEstimateText;
